import Box from '@mui/material/Box';
import PageTitle from '../PageTitle';
import React from 'react';

const IFrame = ({ src = '', name = '' }) => {
  return (<Box sx={{
    padding: '25px',
    display: 'flex',
    flexDirection: 'column',
    rowGap: '25px',
    height: '100%'
  }}>
    <PageTitle>
      { name }
    </PageTitle>
    <div style={{
      height: '100%',
      width: '100%'
    }}>
      <iframe
        src={src}
        width="100%"
        height="100%"
        style={{ border: 'none' }}
      />
    </div>
  </Box>);
};

export default IFrame;
